import { render } from "./BiotronPageUpdated.vue?vue&type=template&id=6780bfd0&scoped=true"
import script from "./BiotronPageUpdated.vue?vue&type=script&lang=js"
export * from "./BiotronPageUpdated.vue?vue&type=script&lang=js"

import "./BiotronPageUpdated.vue?vue&type=style&index=0&id=6780bfd0&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6780bfd0"]])

export default __exports__